import ENV from '../constants/Env';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useStyles } from '../components/rides/rideFormStyles';
import MainLayout from '../components/layout/MainLayout';
import { useSessionContext } from '../contexts/session-context';

export default function EditPortalRide() {
  const { session } = useSessionContext();
  const history = useHistory();
  const classes = useStyles();
  const { rideId } = useParams<{ rideId: string }>();
  const { search } = useLocation();
  const encounterId =
    new URLSearchParams(search).get('ehrEncounterId') ?? undefined;

  const portalBookFeatureFlag = session?.featureFlags?.includes(
    'dashboard_portal_book_ride',
  );

  useEffect(() => {
    // Only redirect when featureFlags are loaded (not undefined)
    if (session?.featureFlags && !portalBookFeatureFlag) {
      history.replace({ pathname: '/' });
    }
  }, [portalBookFeatureFlag, session?.featureFlags, history]);

  const redirectUrl = new URL(`/rides/${rideId}/edit`, ENV.portalUrl);
  redirectUrl.searchParams.set('embeddedInDashboard', 'true');

  if (encounterId) {
    redirectUrl.searchParams.set('ehrEncounterId', encounterId);
  }

  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="Edit Portal Ride"
        src={redirectUrl.toString()}
        className={classes.iframe}
      />
    </MainLayout>
  );
}
